module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_page_copy-2b2b498695fbf531054b15021ea14450.png";